import { Component, Input } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import * as _ from 'lodash';
import { SharedService } from 'app/shared/services/shared.service';
import { HttpService } from 'app/shared/services/http.service';
import { ModalsService } from 'app/shared/services/modals.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { UserService } from 'app/shared/services/user.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'add-user-component',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
})
export class AddUserComponent {
  @Input() public data: any;
  public editMode: boolean;
  public userData: any;
  public exclusiveDomains: Array<any>;
  public isLoading: boolean;
  public subscriptions: Array<any>;

  constructor(
    public sharedService: SharedService,
    public httpService: HttpService,
    public modalsService: ModalsService,
    public dictionaryService: DictionaryService,
    public userService: UserService,
    public ga: GoogleAnalyticsService
  ) {
    this.editMode = false;
    this.data = {};
    this.userData = {};
    this.isLoading = false;
    this.subscriptions = [];
  }

  ngOnDestroy() {}

  ngOnChanges($event: any) {
    let network: any;
    let networkId = '1';
    this.editMode = this.sharedService.getNumOfKeys(this.data.userData) > 0;
    if (this.editMode) {
      network = _.find(this.data.networks, { name: this.data.userData.networkName });
      if (network) {
        networkId = network.networkId;
      }
      this.userData = {
        email: this.data.userData.email,
        network: networkId,
        password: '',
        active: this.data.userData.active,
        type: this.data.userData.type,
        username: this.data.userData.username,
      };
    } else {
      network = _.find(this.data.networks, { name: this.userService.networkData.name });
      if (network) {
        networkId = network.networkId;
      }
      this.userData = {
        email: ' ',
        network: networkId,
        password: null,
        active: true,
        type: 'adv',
        username: null,
      };
    }
  }

  validateForm() {
    let valid = true;
    let errorMessage: string;
    this.userData.email = this.userData.email.trim();
    if (this.sharedService.isEmpty(this.userData.network)) {
      valid = false;
      errorMessage = this.dictionaryService.get('NETWORK') + ' ' + this.dictionaryService.get('IS_REQUIRED');
    } else if (this.sharedService.isEmpty(this.userData.username)) {
      valid = false;
      errorMessage = this.dictionaryService.get('USERNAME') + ' ' + this.dictionaryService.get('IS_REQUIRED');
    } else if (!this.sharedService.validateUsername(this.userData.username)) {
      valid = false;
      errorMessage = this.dictionaryService.get('INVALID_USERNAME');
    } else if (this.sharedService.isEmpty(this.userData.email)) {
      valid = false;
      errorMessage = this.dictionaryService.get('EMAIL') + ' ' + this.dictionaryService.get('IS_REQUIRED');
    } else if (!this.sharedService.validateEmail(this.userData.email)) {
      valid = false;
      errorMessage = this.dictionaryService.get('EMAIL') + ' ' + this.dictionaryService.get('IS_INVALID');
    } else if (this.sharedService.isEmpty(this.userData.password) && !this.editMode) {
      valid = false;
      errorMessage = this.dictionaryService.get('PASSWORD') + ' ' + this.dictionaryService.get('IS_REQUIRED');
    } else if (!this.sharedService.validatePassword(this.userData.password) && !this.editMode) {
      valid = false;
      errorMessage = this.dictionaryService.get('INVALID_PASSWORD');
    }
    if (!valid) {
      this.sharedService.showFlashMessage(errorMessage, 'error');
    }
    return valid;
  }

  saveUser() {
    if (this.validateForm()) {
      const url: string = this.editMode ? 'users_management/updateUser' : 'users_management/createUser';
      let userType: string;
      let params: any;
      switch (this.userData.type) {
        case 'Network User':
          userType = 'adv';
          break;
        case 'Cedato Admin':
          userType = 'admin';
          break;
        default:
          userType = this.userData.type;
      }
      params = {
        userData: {
          email: this.userData.email,
          networkId: this.userData.network,
          password: this.userData.password,
          status: this.userData.active ? 1 : 0,
          type: userType,
          username: this.userData.username,
        },
      };
      if (this.editMode) {
        params.userId = this.data.userData.userId;
      }
      this.isLoading = true;
      this.subscriptions.push(
        this.httpService.post(url, params).subscribe(
          (response) => {
            if (!response.errors) {
              this.sharedService.showFlashMessage(this.dictionaryService.get('USER_SAVED_SUCCESSFULLY'), 'success');
              this.sharedService.sendMessage('USER_UPDATED');
              this.modalsService.hideModal();
              this.isLoading = false;
            } else {
              this.sharedService.showErrorFlashMessage(response.errors);
              this.isLoading = false;
            }
          },
          (error) => {
            this.sharedService.showErrorFlashMessage();
            this.isLoading = false;
          }
        )
      );
    }
  }
}
